export default __webpack_public_path__ + "static/media/YPV2-22-Trainer-InCourseWorkbook.4e783919.pdf";